import { useId } from "react";
import { useOpcoesDoRelatorio } from "../../nucleo/relatorios";
import { PERIODOS } from "../../nucleo/paineis";
import type { FiltroDoWidget, FiltrosGuardados } from "../../nucleo/paineis";

interface Props {
  /** Quais filtros o widget aceita — o que não é aceito nem aparece. */
  aceitos: readonly FiltroDoWidget[];
  valor: FiltrosGuardados;
  aoMudar: (proximo: FiltrosGuardados) => void;
  /** O período que vale quando nada foi escolhido (cada widget tem o seu). */
  periodoPadrao: string;
}

/**
 * Os filtros de um widget — período, empresa e equipe —, no editor e no cartão do painel.
 *
 * Só existe o que o widget aceita: o servidor ignora o resto, e um seletor que não muda o número
 * é o jeito de a pessoa acreditar num recorte que não está valendo.
 */
export function FiltrosDoWidget({ aceitos, valor, aoMudar, periodoPadrao }: Props) {
  const base = useId();
  const precisaDeOpcoes = aceitos.includes("organizacao") || aceitos.includes("equipe");
  const opcoes = useOpcoesDoRelatorio(precisaDeOpcoes);

  function mudar(chave: keyof FiltrosGuardados, texto: string) {
    const proximo = { ...valor };
    if (texto) proximo[chave] = texto;
    else delete proximo[chave];
    aoMudar(proximo);
  }

  return (
    <div className="grid gap-2 grid-cols-1 sm:grid-cols-3" data-testid="filtros-do-widget">
      {aceitos.includes("periodo") ? (
        <label className="campo" htmlFor={`${base}-periodo`}>
          <span className="campo__rotulo">Período</span>
          <select
            id={`${base}-periodo`}
            className="campo__controle"
            value={valor.periodo ?? periodoPadrao}
            onChange={(evento) => mudar("periodo", evento.target.value)}
          >
            {PERIODOS.map(([chave, rotulo]) => (
              <option key={chave} value={chave}>
                {rotulo}
              </option>
            ))}
          </select>
        </label>
      ) : null}
      {aceitos.includes("organizacao") ? (
        <label className="campo" htmlFor={`${base}-organizacao`}>
          <span className="campo__rotulo">Empresa</span>
          <select
            id={`${base}-organizacao`}
            className="campo__controle"
            value={valor.organizacao_id ?? ""}
            onChange={(evento) => mudar("organizacao_id", evento.target.value)}
          >
            <option value="">Todas</option>
            {(opcoes.data?.organizacoes ?? []).map((item) => (
              <option key={item.id} value={item.id}>
                {item.nome}
              </option>
            ))}
          </select>
        </label>
      ) : null}
      {aceitos.includes("equipe") ? (
        <label className="campo" htmlFor={`${base}-equipe`}>
          <span className="campo__rotulo">Equipe</span>
          <select
            id={`${base}-equipe`}
            className="campo__controle"
            value={valor.equipe_id ?? ""}
            onChange={(evento) => mudar("equipe_id", evento.target.value)}
          >
            <option value="">Todas</option>
            {(opcoes.data?.equipes ?? []).map((item) => (
              <option key={item.id} value={item.id}>
                {item.nome}
              </option>
            ))}
          </select>
        </label>
      ) : null}
    </div>
  );
}
